import axios from "axios";
import { Message } from "element-ui";
import store from "@/store";
import router from "@/router";
import { route } from "@/router";

const request = axios.create({
	baseURL: "https://develop.himeit.com/api/",
	timeout: 5000
});

// 添加请求拦截器
request.interceptors.request.use(
	function (config) {
		// 在发送请求之前做些什么
		const token = store.state.user.token;
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	},
	function (error) {
		// 对请求错误做些什么
		return Promise.reject(error);
	}
);

// 添加响应拦截器
request.interceptors.response.use(
	function (response) {
		// 对响应数据做点什么
		if (response.data.code !== 0 && response.data.message) {
			Message({
				type: "warning",
				message: response.data.message,
				center: true
			});
		}
		return response;
	},
	function (error) {
		// 对响应错误做点什么
		if (error.response) {
			if (error.response.status === 401) {
				// 给提示，清除无效token(vuex+本地)，拦到登录
				Message({
					type: "warning",
					message: "当前登录状态已过期！",
					center: true
				});
				store.commit("user/logout");
				const urlId =
					Number(JSON.parse(error.response.config.data).url_id) || "";
				const redirectPath = `/?id=${urlId}`;
				router.push({
					path: "/login",
					query: {
						redirect: redirectPath,
						urlId: urlId
					}
				});
			} else if (error.response.data.message) {
				// 给提示
				Message({
					type: "warning",
					message: error.response.data.message,
					center: true
				});
			}
			return Promise.reject(error);
		}
	}
);

export default request;
